<template>
  <main class="login">
    <section class="login__modal">
      <h1 class="login__header"><img class="login__logo" alt="userboat" src="/static/assets/logo/userboat-full.svg"></h1>
      <h2 class="login__title">{{ L.localize('Welcome') }}</h2>

      <form class="form js-form" data-form="login" @keydown.enter.prevent="login" @keyup.enter="login">

        <span class="form__validation" v-if="error">
          {{ error }}
        </span>

        <TextBox
          label="Label_EmailAddress"
          v-model="email"
          :validate="$v"
          autocomplete="email"
          placeholder="Placeholder_Email"
          modelPath="email"
          acc="email"

          @input="$v.email.$touch"
        />

        <TextBox
          label="Login_Password"
          v-model="password"
          :validate="$v"
          autocomplete="password"
          placeholder="Placeholder_Password"
          modelPath="password"
          type="password"
          acc="password"

          @input="$v.password.$touch"
        />

        <CheckBox v-model="remember" label="Login_RememberMe" />

        <Btn :isLoading="loading" @click="login" label="Login_LoginButton" />

      </form>

      <router-link :to="{ name: 'forgot-password' }" data-acc="forgotPassword" class="login__link link">
          J'ai oublié mon mot de passe
      </router-link>
    </section>
  </main>
</template>

<script>
  import { TextBox, Btn, CheckBox } from 'components/layout/forms'
  import L from 'services/Localization'
  import { Validation } from 'components/helpers'
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'login',
    components: { Validation, TextBox, Btn, CheckBox },
    mounted() {
      if (this.errorMessage) {
        this.error = L.localize(this.errorMessage)
      }
    },
    data() {
      return {
        loading: false,
        email: '',
        password: '',
        remember: true,
        error: '',
        L: L
      }
    },
    computed: {
      errorMessage() {
        return this.$route.query.message
      },
      endpoint() {
        var endpoint = '/account/login'
        if (this.$route.query.returnUrl) {
          endpoint += `?returnUrl=${this.$route.query.returnUrl}`
        }
        return endpoint
      }
    },
    validations: {
      email: { required },
      password: { required }
    },
    methods: {
      login: function() {
        if (this.$v.$invalid) {
          this.$v.$touch()
          return;
        }
        this.loading = true
        this.$parent.callAPI('POST', this.endpoint, {
          Password: this.password,
          RememberMe: this.remember,
          Username: this.email
        }).then(
          // success
          () => {
            // do nothing, application will redirect
          },

          // fail
          (e, reponse) => {
            this.loading = false
            if (e.details) {
              this.error = L.localize(e.details)
            } else {
              this.error = L.localize(e.message)
            }
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Login.vue?36bb2470